/**
 * [AI補完仕様] このコメントはAI補完（コード自動生成）に構造情報として渡されます。変更時は実装品質に直結するため正確に保つこと。
 *
 * 一覧画面向けの共通キーワード検索UI（テキスト入力 + 検索ボタン）。
 *
 * @contract 検索実行はEnterキー押下（IME変換確定前を除く）または検索ボタンクリック時のみ行うこと（入力の都度onSearchを呼ばない）。
 * @contract onSearchには入力欄の現在値をそのまま渡す（trim等の加工は呼び出し側の任意）。
 * @contract 入力欄はバックエンドのq上限（100文字）に合わせ maxLength=100 を設定すること。
 * @signature SearchBox(props: { defaultValue?: string; onSearch: (keyword: string) => void; placeholder?: string }): JSX.Element
 */
import { useState } from 'react';

const MAX_KEYWORD_LENGTH = 100;

interface SearchBoxProps {
  defaultValue?: string;
  onSearch: (keyword: string) => void;
  placeholder?: string;
}

export function SearchBox({ defaultValue = '', onSearch, placeholder }: SearchBoxProps) {
  const [keyword, setKeyword] = useState(defaultValue);

  const handleSearch = () => onSearch(keyword);

  return (
    <div className="search-box" data-testid="search-box">
      <input
        type="text"
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.nativeEvent.isComposing) handleSearch();
        }}
        placeholder={placeholder ?? 'キーワードで検索'}
        aria-label={placeholder ?? 'キーワードで検索'}
        maxLength={MAX_KEYWORD_LENGTH}
        data-testid="search-box-input"
      />
      <button type="button" onClick={handleSearch} data-testid="search-box-submit">
        検索
      </button>
    </div>
  );
}
